export class CreateAggregationServingTokenRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateAggregationServingTokenRequest.attributeTypeMap;
    }
    constructor() {
    }
}
